(function () {
var $5e9a8971e8a97b1b$var$SSR_NODE = 1;
var $5e9a8971e8a97b1b$var$TEXT_NODE = 3;
var $5e9a8971e8a97b1b$var$EMPTY_OBJ = {};
var $5e9a8971e8a97b1b$var$EMPTY_ARR = [];
var $5e9a8971e8a97b1b$var$SVG_NS = "http://www.w3.org/2000/svg";
var $5e9a8971e8a97b1b$var$id = (a)=>a;
var $5e9a8971e8a97b1b$var$map = $5e9a8971e8a97b1b$var$EMPTY_ARR.map;
var $5e9a8971e8a97b1b$var$isArray = Array.isArray;
var $5e9a8971e8a97b1b$var$enqueue = typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : setTimeout;
var $5e9a8971e8a97b1b$var$createClass = (obj)=>{
    var out = "";
    if (typeof obj === "string") return obj;
    if ($5e9a8971e8a97b1b$var$isArray(obj)) {
        for(var k = 0, tmp; k < obj.length; k++)if (tmp = $5e9a8971e8a97b1b$var$createClass(obj[k])) out += (out && " ") + tmp;
    } else {
        for(var k in obj)if (obj[k]) out += (out && " ") + k;
    }
    return out;
};
var $5e9a8971e8a97b1b$var$shouldRestart = (a, b)=>{
    for(var k in {
        ...a,
        ...b
    }){
        if (typeof ($5e9a8971e8a97b1b$var$isArray(a[k]) ? a[k][0] : a[k]) === "function") b[k] = a[k];
        else if (a[k] !== b[k]) return true;
    }
};
var $5e9a8971e8a97b1b$var$patchSubs = (oldSubs, newSubs = $5e9a8971e8a97b1b$var$EMPTY_ARR, dispatch)=>{
    for(var subs = [], i = 0, oldSub, newSub; i < oldSubs.length || i < newSubs.length; i++){
        oldSub = oldSubs[i];
        newSub = newSubs[i];
        subs.push(newSub && newSub !== true ? !oldSub || newSub[0] !== oldSub[0] || $5e9a8971e8a97b1b$var$shouldRestart(newSub[1], oldSub[1]) ? [
            newSub[0],
            newSub[1],
            (oldSub && oldSub[2](), newSub[0](dispatch, newSub[1]))
        ] : oldSub : oldSub && oldSub[2]());
    }
    return subs;
};
var $5e9a8971e8a97b1b$var$getKey = (vdom)=>vdom == null ? vdom : vdom.key;
var $5e9a8971e8a97b1b$var$patchProperty = (node, key, oldValue, newValue, listener, isSvg)=>{
    if (key === "style") for(var k in {
        ...oldValue,
        ...newValue
    }){
        oldValue = newValue == null || newValue[k] == null ? "" : newValue[k];
        if (k[0] === "-") node[key].setProperty(k, oldValue);
        else node[key][k] = oldValue;
    }
    else if (key[0] === "o" && key[1] === "n") {
        if (!((node.events || (node.events = {}))[key = key.slice(2)] = newValue)) node.removeEventListener(key, listener);
        else if (!oldValue) node.addEventListener(key, listener);
    } else if (!isSvg && key !== "list" && key !== "form" && key in node) node[key] = newValue == null ? "" : newValue;
    else if (newValue == null || newValue === false) node.removeAttribute(key);
    else node.setAttribute(key, newValue);
};
var $5e9a8971e8a97b1b$var$createNode = (vdom, listener, isSvg)=>{
    var props = vdom.props;
    var node = vdom.type === $5e9a8971e8a97b1b$var$TEXT_NODE ? document.createTextNode(vdom.tag) : (isSvg = isSvg || vdom.tag === "svg") ? document.createElementNS($5e9a8971e8a97b1b$var$SVG_NS, vdom.tag, props.is && props) : document.createElement(vdom.tag, props.is && props);
    for(var k in props)$5e9a8971e8a97b1b$var$patchProperty(node, k, null, props[k], listener, isSvg);
    for(var i = 0; i < vdom.children.length; i++)node.appendChild($5e9a8971e8a97b1b$var$createNode(vdom.children[i] = $5e9a8971e8a97b1b$var$maybeVNode(vdom.children[i]), listener, isSvg));
    return vdom.node = node;
};
var $5e9a8971e8a97b1b$var$patch = (parent, node, oldVNode, newVNode, listener, isSvg)=>{
    if (oldVNode === newVNode) ;
    else if (oldVNode != null && oldVNode.type === $5e9a8971e8a97b1b$var$TEXT_NODE && newVNode.type === $5e9a8971e8a97b1b$var$TEXT_NODE) {
        if (oldVNode.tag !== newVNode.tag) node.nodeValue = newVNode.tag;
    } else if (oldVNode == null || oldVNode.tag !== newVNode.tag) {
        node = parent.insertBefore($5e9a8971e8a97b1b$var$createNode(newVNode = $5e9a8971e8a97b1b$var$maybeVNode(newVNode), listener, isSvg), node);
        if (oldVNode != null) parent.removeChild(oldVNode.node);
    } else {
        var tmpVKid;
        var oldVKid;
        var oldKey;
        var newKey;
        var oldProps = oldVNode.props;
        var newProps = newVNode.props;
        var oldVKids = oldVNode.children;
        var newVKids = newVNode.children;
        var oldHead = 0;
        var newHead = 0;
        var oldTail = oldVKids.length - 1;
        var newTail = newVKids.length - 1;
        isSvg = isSvg || newVNode.tag === "svg";
        for(var i in {
            ...oldProps,
            ...newProps
        })if ((i === "value" || i === "selected" || i === "checked" ? node[i] : oldProps[i]) !== newProps[i]) $5e9a8971e8a97b1b$var$patchProperty(node, i, oldProps[i], newProps[i], listener, isSvg);
        while(newHead <= newTail && oldHead <= oldTail){
            if ((oldKey = $5e9a8971e8a97b1b$var$getKey(oldVKids[oldHead])) == null || oldKey !== $5e9a8971e8a97b1b$var$getKey(newVKids[newHead])) break;
            $5e9a8971e8a97b1b$var$patch(node, oldVKids[oldHead].node, oldVKids[oldHead], newVKids[newHead] = $5e9a8971e8a97b1b$var$maybeVNode(newVKids[newHead++], oldVKids[oldHead++]), listener, isSvg);
        }
        while(newHead <= newTail && oldHead <= oldTail){
            if ((oldKey = $5e9a8971e8a97b1b$var$getKey(oldVKids[oldTail])) == null || oldKey !== $5e9a8971e8a97b1b$var$getKey(newVKids[newTail])) break;
            $5e9a8971e8a97b1b$var$patch(node, oldVKids[oldTail].node, oldVKids[oldTail], newVKids[newTail] = $5e9a8971e8a97b1b$var$maybeVNode(newVKids[newTail--], oldVKids[oldTail--]), listener, isSvg);
        }
        if (oldHead > oldTail) while(newHead <= newTail)node.insertBefore($5e9a8971e8a97b1b$var$createNode(newVKids[newHead] = $5e9a8971e8a97b1b$var$maybeVNode(newVKids[newHead++]), listener, isSvg), (oldVKid = oldVKids[oldHead]) && oldVKid.node);
        else if (newHead > newTail) while(oldHead <= oldTail)node.removeChild(oldVKids[oldHead++].node);
        else {
            for(var keyed = {}, newKeyed = {}, i = oldHead; i <= oldTail; i++)if ((oldKey = oldVKids[i].key) != null) keyed[oldKey] = oldVKids[i];
            while(newHead <= newTail){
                oldKey = $5e9a8971e8a97b1b$var$getKey(oldVKid = oldVKids[oldHead]);
                newKey = $5e9a8971e8a97b1b$var$getKey(newVKids[newHead] = $5e9a8971e8a97b1b$var$maybeVNode(newVKids[newHead], oldVKid));
                if (newKeyed[oldKey] || newKey != null && newKey === $5e9a8971e8a97b1b$var$getKey(oldVKids[oldHead + 1])) {
                    if (oldKey == null) node.removeChild(oldVKid.node);
                    oldHead++;
                    continue;
                }
                if (newKey == null || oldVNode.type === $5e9a8971e8a97b1b$var$SSR_NODE) {
                    if (oldKey == null) {
                        $5e9a8971e8a97b1b$var$patch(node, oldVKid && oldVKid.node, oldVKid, newVKids[newHead], listener, isSvg);
                        newHead++;
                    }
                    oldHead++;
                } else {
                    if (oldKey === newKey) {
                        $5e9a8971e8a97b1b$var$patch(node, oldVKid.node, oldVKid, newVKids[newHead], listener, isSvg);
                        newKeyed[newKey] = true;
                        oldHead++;
                    } else if ((tmpVKid = keyed[newKey]) != null) {
                        $5e9a8971e8a97b1b$var$patch(node, node.insertBefore(tmpVKid.node, oldVKid && oldVKid.node), tmpVKid, newVKids[newHead], listener, isSvg);
                        newKeyed[newKey] = true;
                    } else $5e9a8971e8a97b1b$var$patch(node, oldVKid && oldVKid.node, null, newVKids[newHead], listener, isSvg);
                    newHead++;
                }
            }
            while(oldHead <= oldTail)if ($5e9a8971e8a97b1b$var$getKey(oldVKid = oldVKids[oldHead++]) == null) node.removeChild(oldVKid.node);
            for(var i in keyed)if (newKeyed[i] == null) node.removeChild(keyed[i].node);
        }
    }
    return newVNode.node = node;
};
var $5e9a8971e8a97b1b$var$propsChanged = (a, b)=>{
    for(var k in a)if (a[k] !== b[k]) return true;
    for(var k in b)if (a[k] !== b[k]) return true;
};
var $5e9a8971e8a97b1b$var$maybeVNode = (newVNode, oldVNode)=>newVNode !== true && newVNode !== false && newVNode ? typeof newVNode.tag === "function" ? ((!oldVNode || oldVNode.memo == null || $5e9a8971e8a97b1b$var$propsChanged(oldVNode.memo, newVNode.memo)) && ((oldVNode = newVNode.tag(newVNode.memo)).memo = newVNode.memo), oldVNode) : newVNode : $5e9a8971e8a97b1b$export$6f093cfa640b7166("");
var $5e9a8971e8a97b1b$var$recycleNode = (node)=>node.nodeType === $5e9a8971e8a97b1b$var$TEXT_NODE ? $5e9a8971e8a97b1b$export$6f093cfa640b7166(node.nodeValue, node) : $5e9a8971e8a97b1b$var$createVNode(node.nodeName.toLowerCase(), $5e9a8971e8a97b1b$var$EMPTY_OBJ, $5e9a8971e8a97b1b$var$map.call(node.childNodes, $5e9a8971e8a97b1b$var$recycleNode), $5e9a8971e8a97b1b$var$SSR_NODE, node);
var $5e9a8971e8a97b1b$var$createVNode = (tag, { key: key, ...props }, children, type, node)=>({
        tag: tag,
        props: props,
        key: key,
        children: children,
        type: type,
        node: node
    });
var $5e9a8971e8a97b1b$export$7c73462e0d25e514 = (tag, memo)=>({
        tag: tag,
        memo: memo
    });
var $5e9a8971e8a97b1b$export$6f093cfa640b7166 = (value, node)=>$5e9a8971e8a97b1b$var$createVNode(value, $5e9a8971e8a97b1b$var$EMPTY_OBJ, $5e9a8971e8a97b1b$var$EMPTY_ARR, $5e9a8971e8a97b1b$var$TEXT_NODE, node);
var $5e9a8971e8a97b1b$export$dda1d9f60106f0e9 = (tag, { class: c, ...props }, children = $5e9a8971e8a97b1b$var$EMPTY_ARR)=>$5e9a8971e8a97b1b$var$createVNode(tag, {
        ...props,
        ...c ? {
            class: $5e9a8971e8a97b1b$var$createClass(c)
        } : $5e9a8971e8a97b1b$var$EMPTY_OBJ
    }, $5e9a8971e8a97b1b$var$isArray(children) ? children : [
        children
    ]);
var $5e9a8971e8a97b1b$export$729c8b7179294ba = ({ node: node, view: view, subscriptions: subscriptions, dispatch: dispatch = $5e9a8971e8a97b1b$var$id, init: init = $5e9a8971e8a97b1b$var$EMPTY_OBJ })=>{
    var vdom = node && $5e9a8971e8a97b1b$var$recycleNode(node);
    var subs = [];
    var state;
    var busy;
    var update = (newState)=>{
        if (state !== newState) {
            if ((state = newState) == null) dispatch = subscriptions = render = $5e9a8971e8a97b1b$var$id;
            if (subscriptions) subs = $5e9a8971e8a97b1b$var$patchSubs(subs, subscriptions(state), dispatch);
            if (view && !busy) $5e9a8971e8a97b1b$var$enqueue(render, busy = true);
        }
    };
    var render = ()=>node = $5e9a8971e8a97b1b$var$patch(node.parentNode, node, vdom, vdom = view(state), listener, busy = false);
    var listener = function(event) {
        dispatch(this.events[event.type], event);
    };
    return (dispatch = dispatch((action, props)=>typeof action === "function" ? dispatch(action(state, props)) : $5e9a8971e8a97b1b$var$isArray(action) ? typeof action[0] === "function" ? dispatch(action[0], action[1]) : action.slice(1).map((fx)=>fx && fx !== true && (fx[0] || fx)(dispatch, fx[1]), update(action[0])) : update(action)))(init), dispatch;
};


const $7db44d89e56f69aa$export$4162dbd8c730437 = 13;
const $7db44d89e56f69aa$export$3ea83e27c899ea29 = {
    All: 0,
    Active: 1,
    Completed: 2
};
const $7db44d89e56f69aa$export$31b40729666a4ae0 = ()=>{
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
const $7db44d89e56f69aa$export$276debc7da0dca8f = (todos, id, ...todo)=>{
    const todoItem = todo[0];
    return todos.map((t)=>id === t.id ? Object.assign({}, t, todoItem) : t);
};


var $bd83118c62e5e9b1$export$2e2bcd8739ae039 = {
    input: '',
    placeholder: 'What needs to be done?',
    todos: [],
    filter: (0, $7db44d89e56f69aa$export$3ea83e27c899ea29).All
};


const $bc7fa6518e0aa222$var$STORAGE_KEY = 'todos-hyperapp';
var $bc7fa6518e0aa222$export$2e2bcd8739ae039 = {
    fetch: ()=>JSON.parse(localStorage.getItem($bc7fa6518e0aa222$var$STORAGE_KEY) || '[]'),
    save: (todos)=>localStorage.setItem($bc7fa6518e0aa222$var$STORAGE_KEY, JSON.stringify(todos))
};




var $9927ae1d1cc6f0ba$export$2e2bcd8739ae039 = ()=>(0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('header', {
        class: 'header'
    }, [
        (0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('h1', {}, (0, $5e9a8971e8a97b1b$export$6f093cfa640b7166)('todos'))
    ]);



var $e0a09b7ef8d7abfe$export$2e2bcd8739ae039 = ()=>(0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('footer', {
        class: 'info'
    }, [
        (0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('p', {}, (0, $5e9a8971e8a97b1b$export$6f093cfa640b7166)('Double-click to edit a todo')),
        (0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('p', {}, [
            (0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('span', {}, (0, $5e9a8971e8a97b1b$export$6f093cfa640b7166)('Written by ')),
            (0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('a', {
                href: 'https://dangthanh.org'
            }, (0, $5e9a8971e8a97b1b$export$6f093cfa640b7166)('Dang Van Thanh'))
        ]),
        (0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('p', {}, [
            (0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('span', {}, (0, $5e9a8971e8a97b1b$export$6f093cfa640b7166)('Part of ')),
            (0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('a', {
                href: 'https://todomvc.com'
            }, (0, $5e9a8971e8a97b1b$export$6f093cfa640b7166)('TodoMVC'))
        ])
    ]);





const $6cce77b7e51011b0$var$NewTodo = (value)=>({
        id: (0, $7db44d89e56f69aa$export$31b40729666a4ae0)(),
        done: false,
        editing: false,
        value: value
    });
const $6cce77b7e51011b0$var$OnInput = (state, event)=>{
    const input = event.target.value;
    const newState = {
        ...state,
        input: input
    };
    return newState;
};
const $6cce77b7e51011b0$var$AddTodo = (state, event)=>{
    const todos = state.todos.concat($6cce77b7e51011b0$var$NewTodo(event.target.value));
    (0, $bc7fa6518e0aa222$export$2e2bcd8739ae039).save(todos);
    const newState = {
        ...state,
        input: '',
        todos: todos
    };
    return newState;
};
const $6cce77b7e51011b0$var$OnKeyDown = (state, event)=>{
    if (event.keyCode === (0, $7db44d89e56f69aa$export$4162dbd8c730437) && event.target.value !== '') return $6cce77b7e51011b0$var$AddTodo(state, event);
    return state;
};
var $6cce77b7e51011b0$export$2e2bcd8739ae039 = (props)=>(0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('div', {}, [
        (0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('input', {
            type: 'text',
            class: 'new-todo',
            onkeydown: $6cce77b7e51011b0$var$OnKeyDown,
            oninput: $6cce77b7e51011b0$var$OnInput,
            value: props.input,
            placeholder: props.placeholder
        })
    ]);





const $c75142eea0f8ac52$var$ToggleAllTodo = (state, e)=>{
    let isCheckedAll = e.target.previousSibling.checked;
    isCheckedAll = !isCheckedAll;
    const todos = state.todos.map((t)=>{
        t.done = isCheckedAll;
        return t;
    });
    (0, $bc7fa6518e0aa222$export$2e2bcd8739ae039).save(todos);
    const newState = {
        ...state,
        todos: todos
    };
    return newState;
};
var $c75142eea0f8ac52$export$2e2bcd8739ae039 = ()=>(0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('div', {}, [
        (0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('input', {
            type: 'checkbox',
            class: 'toggle-all',
            id: 'toggle-all'
        }),
        (0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('label', {
            for: 'toggle-all',
            onclick: (state, e)=>$c75142eea0f8ac52$var$ToggleAllTodo(state, e)
        }, (0, $5e9a8971e8a97b1b$export$6f093cfa640b7166)('Mark all as complete'))
    ]);


var $75bb4c47fbab0b70$export$2e2bcd8739ae039 = (props)=>(0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('section', {
        class: 'main'
    }, props.todos.filter((t)=>!t.done).length > 0 ? (0, $c75142eea0f8ac52$export$2e2bcd8739ae039)() : (0, $5e9a8971e8a97b1b$export$6f093cfa640b7166)(''));







const $2113abf6bdd04e9b$var$RemoveTodo = (state, uuid)=>{
    const todos = state.todos.filter((t)=>uuid !== t.id);
    (0, $bc7fa6518e0aa222$export$2e2bcd8739ae039).save(todos);
    const newState = {
        ...state,
        todos: todos
    };
    return newState;
};
const $2113abf6bdd04e9b$var$ToggleTodo = (state, uuid)=>{
    const todos = state.todos.map((t)=>uuid === t.id ? Object.assign({}, t, {
            done: !t.done
        }) : t);
    (0, $bc7fa6518e0aa222$export$2e2bcd8739ae039).save(todos);
    const newState = {
        ...state,
        todos: todos
    };
    return newState;
};
const $2113abf6bdd04e9b$var$EditEnterTodo = (state, e, uuid)=>{
    const todos = (0, $7db44d89e56f69aa$export$276debc7da0dca8f)(state.todos, uuid, {
        editing: true
    });
    (0, $bc7fa6518e0aa222$export$2e2bcd8739ae039).save(todos);
    const input = e.target.parentNode.parentNode.querySelector('.edit');
    input.focus();
    const newState = {
        ...state,
        todos: todos
    };
    return newState;
};
const $2113abf6bdd04e9b$var$EditUpdateTodo = (state, e, uuid)=>{
    const todos = (0, $7db44d89e56f69aa$export$276debc7da0dca8f)(state.todos, uuid, {
        editing: false,
        value: e.target.value
    });
    (0, $bc7fa6518e0aa222$export$2e2bcd8739ae039).save(todos);
    const newState = {
        ...state,
        todos: todos
    };
    return newState;
};
const $2113abf6bdd04e9b$var$OnKeyUp = (state, e, todoId)=>{
    if (e.keyCode === (0, $7db44d89e56f69aa$export$4162dbd8c730437)) return $2113abf6bdd04e9b$var$EditUpdateTodo(state, e, todoId);
    return state;
};
var $2113abf6bdd04e9b$export$2e2bcd8739ae039 = (todo)=>(0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('li', {
        class: [
            'todo',
            {
                completed: todo.done,
                editing: todo.editing
            }
        ]
    }, [
        (0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('div', {
            class: 'view'
        }, [
            (0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('input', {
                type: 'checkbox',
                class: 'toggle',
                checked: !!todo.done,
                onclick: [
                    $2113abf6bdd04e9b$var$ToggleTodo,
                    todo.id
                ]
            }),
            (0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('label', {
                ondblclick: (state, e)=>$2113abf6bdd04e9b$var$EditEnterTodo(state, e, todo.id)
            }, (0, $5e9a8971e8a97b1b$export$6f093cfa640b7166)(todo.value)),
            (0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('button', {
                class: 'destroy',
                onclick: [
                    $2113abf6bdd04e9b$var$RemoveTodo,
                    todo.id
                ]
            }, (0, $5e9a8971e8a97b1b$export$6f093cfa640b7166)(''))
        ]),
        (0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('input', {
            type: 'text',
            class: 'edit',
            value: todo.value,
            onkeyup: (state, e)=>$2113abf6bdd04e9b$var$OnKeyUp(state, e, todo.id),
            onblur: (state, e)=>$2113abf6bdd04e9b$var$EditUpdateTodo(state, e, todo.id)
        })
    ]);


var $5f7f60145a713c02$export$2e2bcd8739ae039 = ({ todos: todos, filter: filter })=>(0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('ul', {
        class: 'todo-list'
    }, todos.filter((t)=>filter === (0, $7db44d89e56f69aa$export$3ea83e27c899ea29).Completed ? t.done : filter === (0, $7db44d89e56f69aa$export$3ea83e27c899ea29).Active ? !t.done : filter === (0, $7db44d89e56f69aa$export$3ea83e27c899ea29).All).map((todo)=>(0, $2113abf6bdd04e9b$export$2e2bcd8739ae039)(todo)));





const $25a93503b5ac20e0$var$ClearCompleted = (state)=>{
    const todos = state.todos.filter((t)=>!t.done);
    (0, $bc7fa6518e0aa222$export$2e2bcd8739ae039).save(todos);
    const newState = {
        ...state,
        todos: todos
    };
    return newState;
};
const $25a93503b5ac20e0$var$FilterTodo = (state, filter)=>{
    const newState = {
        ...state,
        filter: filter
    };
    return newState;
};
var $25a93503b5ac20e0$export$2e2bcd8739ae039 = (props)=>(0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('footer', {
        class: 'footer'
    }, [
        (0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('span', {
            class: 'todo-count'
        }, (0, $5e9a8971e8a97b1b$export$6f093cfa640b7166)(`${props.todos.filter((t)=>!t.done).length} item left`)),
        (0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('ul', {
            class: 'filters'
        }, Object.keys((0, $7db44d89e56f69aa$export$3ea83e27c899ea29)).map((key)=>(0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('li', {}, (0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('a', {
                class: props.filter === (0, $7db44d89e56f69aa$export$3ea83e27c899ea29)[key] ? 'selected' : '',
                onclick: (state, e)=>$25a93503b5ac20e0$var$FilterTodo(state, (0, $7db44d89e56f69aa$export$3ea83e27c899ea29)[key])
            }, (0, $5e9a8971e8a97b1b$export$6f093cfa640b7166)(key))))),
        props.todos.filter((t)=>t.done).length > 0 ? (0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('button', {
            class: 'clear-completed',
            onclick: $25a93503b5ac20e0$var$ClearCompleted
        }, (0, $5e9a8971e8a97b1b$export$6f093cfa640b7166)('Clear completed')) : (0, $5e9a8971e8a97b1b$export$6f093cfa640b7166)('')
    ]);


const $46e16eef4f4224ac$var$App = (state)=>(0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('div', {
        class: 'container'
    }, [
        (0, $5e9a8971e8a97b1b$export$dda1d9f60106f0e9)('section', {
            class: 'todoapp'
        }, [
            (0, $9927ae1d1cc6f0ba$export$2e2bcd8739ae039)(),
            (0, $6cce77b7e51011b0$export$2e2bcd8739ae039)(state),
            (0, $75bb4c47fbab0b70$export$2e2bcd8739ae039)(state),
            (0, $5f7f60145a713c02$export$2e2bcd8739ae039)({
                todos: state.todos,
                filter: state.filter
            }),
            (0, $25a93503b5ac20e0$export$2e2bcd8739ae039)(state)
        ]),
        (0, $e0a09b7ef8d7abfe$export$2e2bcd8739ae039)()
    ]);
var $46e16eef4f4224ac$export$2e2bcd8739ae039 = $46e16eef4f4224ac$var$App;


(0, $bd83118c62e5e9b1$export$2e2bcd8739ae039).todos = (0, $bc7fa6518e0aa222$export$2e2bcd8739ae039).fetch();
(0, $bd83118c62e5e9b1$export$2e2bcd8739ae039).todos = (0, $bd83118c62e5e9b1$export$2e2bcd8739ae039).todos.map((todo)=>{
    todo.editing = false;
    return todo;
});
const $3015b282b063971c$var$InitApp = (state)=>state;
const $3015b282b063971c$var$init = $3015b282b063971c$var$InitApp((0, $bd83118c62e5e9b1$export$2e2bcd8739ae039));
const $3015b282b063971c$var$view = (state)=>(0, $46e16eef4f4224ac$export$2e2bcd8739ae039)(state);
const $3015b282b063971c$var$node = document.getElementById('app');
(0, $5e9a8971e8a97b1b$export$729c8b7179294ba)({
    init: $3015b282b063971c$var$init,
    view: $3015b282b063971c$var$view,
    node: $3015b282b063971c$var$node
});

})();
//# sourceMappingURL=repo.8f5de2a6.js.map
